export default __webpack_public_path__ + "static/media/huddersfieldUniRentals.7c3839e1.png";